module.exports = "<p>\n    <input type=\"file\" accept=\".csv\" (change)=\"convertFile($event)\" />  \n</p>\n"